module.exports = __webpack_public_path__ + "static/media/daibiao-title-6.404f516c.png";